module.exports = __webpack_public_path__ + "static/media/bombilla-zona.6b29f1af.svg";